import React, { Component } from "react";
import styles from './styles.css'
import { __makeTemplateObject } from "tslib";

class Floaty extends Component {
  constructor(props) {
    super(props);

    this.reposition = this.reposition.bind(this)

    this.state = {
      floatyDimensions: { height: 100, width: 147 },
      duration: 5,
      speedConstant: 4,
      xPositive: true,
      yPositive: true,
      x: 100,
      y: 0
    }
  }

  componentDidMount() {
    setTimeout(() => {
      this.positionFloaty()

      this.setState({
        floatyDimensions: {
          height: this.image.clientHeight,
          width: this.image.clientWidth
        }
      })
    }, 300);
  }

  absoluteHeight() {
    return this.props.parentHeight - this.state.floatyDimensions.height
  }

  absoluteWidth() {
    return this.props.parentWidth - this.state.floatyDimensions.width
  }

  bouncedOffX() {
    return this.state.x == 0 || this.state.x >= this.absoluteWidth()
  }

  bouncedOffY() {
    return this.state.y == 0 || this.state.y == this.absoluteHeight()
  }

  screenIsLandscape() {
    return this.absoluteWidth() > this.absoluteHeight()
  }

  reposition(event) {
    if (event.propertyName == 'bottom') {
      this.positionFloaty()
    }
  }

  getAdjacent() {
    if (!this.state.xPositive) return this.state.x

    return this.absoluteWidth() - this.state.x - this.state.floatyDimensions.width
  }

  getOpposite() {
    if (!this.state.yPositive) return this.state.y

    return this.absoluteHeight() - this.state.y - this.state.floatyDimensions.height
  }

  calculateMaxDegrees(opposite, adjacent) {
    if (this.bouncedOffX()) {
      return Math.atan(adjacent / opposite) * (180 / Math.PI);
    }

    if (this.bouncedOffY()) {
      return Math.atan(opposite / adjacent) * (180 / Math.PI);
    }
  }

  calculateAngle(opposite, adjacent) {
    const maxDegrees = this.calculateMaxDegrees(opposite, adjacent)
    const degrees = Math.floor(Math.random() * (maxDegrees - 5)) + 5

    return degrees * (Math.PI / 180)
  }

  calculateNewPoint(opposite, adjacent, angle) {
    let x, y

    if (this.bouncedOffX()) {
      if (this.state.yPositive) {
        y = this.absoluteHeight()

        this.state.yPositive = false
      } else {
        y = 0

        this.state.yPositive = true
      }

      x = Math.tan(angle) * opposite

      if (this.state.x == this.absoluteWidth()) {
        x = this.state.x - x
      }
    } else if (this.bouncedOffY()) {
      if (this.state.xPositive) {
        x = this.absoluteWidth()

        this.state.xPositive = false
      } else {
        x = 0

        this.state.xPositive = true
      }

      y = Math.tan(angle) * adjacent

      if (this.state.y >= this.absoluteHeight()) {
        y = this.state.y - y
      }
    }

    return { x, y }
  }

  positionFloaty() {
    const adjacent = this.getAdjacent()
    const opposite = this.getOpposite()
    const angle = this.calculateAngle(opposite, adjacent)

    const { x, y } = this.calculateNewPoint(opposite, adjacent, angle)
    const duration = this.calculateDuration(x, y)

    this.setState({ y: y, x: x, duration: duration})
  }

  calculateDuration(x, y) {
    const distanceX = (x > this.state.x) ? x - this.state.x : this.state.x - x
    const distanceY = (y > this.state.y) ? y - this.state.y : this.state.y - y

    const distance = Math.sqrt(Math.pow(distanceX, 2) + Math.pow(distanceY, 2))

    const speedComparison = this.screenIsLandscape() ? this.absoluteWidth() : this.absoluteHeight()
    const speed = this.state.speedConstant / speedComparison

    return distance * speed
  }

  render() {
    const floatyPosition = {
      bottom: `${this.state.y}px`,
      left: `${this.state.x}px`,
      transitionDuration: `${this.state.duration}s`
    }

    return (
      <div className='floaty' style={floatyPosition} onTransitionEnd={this.reposition}>
        <img ref={(image) => this.image = image} className={this.props.class} src={this.props.img} />
      </div>
    )
  }
}

export default Floaty;



// WEBPACK FOOTER //
// ./src/components/Floaty/index.js